import { useCallback } from 'react'
import { config } from '../../../../components/Init/Init'
import { filterByTags } from '../../../../services/utils'
import parseCategories from '../../../../services/content/parseCategories'
import { useParseBanners } from './useParseBanners'
import { usePlayerStore } from '../../../../services/store'

export const useParseLobbyData = () => {
  const playerStore = usePlayerStore()
  const playerTagsBanner = playerStore.use.tagsBanner()
  const playerTagsGames = playerStore.use.tagsGames()

  const { parseBanners } = useParseBanners()

  const parseLobbyData = useCallback(
    (response, options) => {
      if (response) {
        let banners = response.entry.banners
        let bannersVersion = 1
        if (config.bannersVersion === 2) {
          banners = filterByTags(response.entry.bannersv2, 'bannerTags', playerTagsBanner)
          bannersVersion = 2
        }

        return {
          id: response.entry.lobbyId,
          banners: parseBanners(banners, bannersVersion),
          categories: parseCategories(
            response.entry.lobbyCategoryAssortments,
            playerTagsGames,
            options.lazyLoadedCategoryIds
          )
        }
      }

      return {
        id: 0,
        banners: [],
        categories: []
      }
    },
    [parseBanners, playerTagsBanner, playerTagsGames]
  )

  return { parseLobbyData }
}
